import Foot from "../Footer/Footer";
import "./About.css";
import Navigations from "../NavBar/Navbar";
import logo from "./2a.png";

import { HashLink } from "react-router-hash-link";

import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import ScrollToTop from "../ScrollToTop";

export const About = () => {

    useEffect(() => {
        Aos.init();
    }, []);

    return <section id="about">
        <ScrollToTop />
        <Navigations />

        <div className="about-cont">

            <div className="bl-about-1">

            <img src={logo} alt="logo" className="about-logo" data-aos="fade-up" data-aos-duration="1300"/>

                <h4 data-aos="fade-up" data-aos-duration="1300">Welcome to Landscape King, your trusted partner in pool maintenance.</h4>
                <p data-aos="fade-up" data-aos-duration="1300">At Landscape King, we take pride in providing high-quality pool maintenance services that ensure the cleanliness, safety, and attractiveness of your pool all year.
                    Our team of professionals, with years of experience, is dedicated to delivering personalized service and exceptional care to each client.
                </p>

                <h4 data-aos="fade-up" data-aos-duration="1300">Why Choose Us?</h4>
                <ul data-aos="fade-up" data-aos-duration="1300">
                    <li> Experience and Reliability: We have extensive experience in maintaining pools of various types and sizes. Our specialists are trained and certified to perform all necessary pool care and repair procedures.</li>
                    <li>Comprehensive Services: We offer complete pool maintenance solutions, including weekly service, pool cleaning, water testing, chemical balancing, equipment checks, and more.</li>
                    <li>Personalized Approach: We understand that every pool is unique, which is why our services are tailored to meet the specific needs of each client. We provide both standard and premium service packages.</li>
                </ul>

                <h4 data-aos="fade-up" data-aos-duration="1300">Our Promise</h4>

                <p data-aos="fade-up" data-aos-duration="1300">We strive to ensure that you can enjoy your pool without worrying about its condition. At Landscape King, we believe that your satisfaction is our best advertisement. That's why we work hard to ensure that every client is happy with our services.</p>


                <h4 data-aos="fade-up" data-aos-duration="1300">Contact Us</h4>

                <p data-aos="fade-up" data-aos-duration="1300">Ready to start working with us? Contact us today to discuss your needs and choose the perfect maintenance package for your pool. We look forward to helping you create the ideal conditions for relaxation and fun in your pool.</p>

                <HashLink to="/#contact" data-aos="fade-up" data-aos-duration="1300" className="link-about">Get In Touch</HashLink>
            </div>

            <div className="bl-about-2" ata-aos="zoom-in" data-aos-duration="1300">
                <img src={logo} alt="logo" />
            </div>
        </div>
        <Foot />
    </section>
}